export default "__VITE_ASSET__Mh5hPVdx__"